import { useState, useEffect } from "react";
import "../../assets/css/systemNotifications.css";

/**
 * STANDARD SYSTEM EVENTS (must match backend)
 */
const EVENTS = [
  { key: "STAFF_CREATED", label: "Staff Created" },
  { key: "STAFF_APPROVED", label: "Staff Approved" },
  { key: "LOAN_SUBMITTED", label: "Loan Submitted" },
  { key: "LOAN_APPROVED", label: "Loan Approved" },
  { key: "LOAN_REJECTED", label: "Loan Rejected" },
];

/**
 * ALLOWED TEMPLATE VARIABLES
 */
const VARIABLES = [
  "{{first_name}}",
  "{{last_name}}",
  "{{email}}",
  "{{role}}",
  "{{department}}",
  "{{designation}}",
  "{{state}}",
  "{{loan_amount}}",
  "{{loan_status}}",
  "{{company_name}}",
];

export default function SystemNotifications() {




  const [selectedEvent, setSelectedEvent] = useState("STAFF_CREATED");
  const [copiedVar, setCopiedVar] = useState(null);
  const [showPreview, setShowPreview] = useState(false);

  const [showConfirmSave, setShowConfirmSave] = useState(false);
const [saving, setSaving] = useState(false);

const [toast, setToast] = useState(null);



function Toast({ toast, onClose }) {
  useEffect(() => {
    if (!toast) return;
    const timer = setTimeout(onClose, 4000);
    return () => clearTimeout(timer);
  }, [toast, onClose]);

  if (!toast) return null;

  return (
    <div className={`app-toast ${toast.type}`}>
      <div className="toast-icon">
        {toast.type === "success" ? "✓" : "✕"}
      </div>

      <div className="toast-content">
        <strong>{toast.title}</strong>
        <p>{toast.message}</p>
      </div>

      <button className="toast-close" onClick={onClose}>
        ×
      </button>
    </div>
  );
}


useEffect(() => {
  fetch(
    "http://localhost/GMT_TECHNOLOGIES_LIMITED_CLEAN/public_html/gmt-api/notifications/templates.php"
  )
    .then(res => res.json())
    .then(data => {
      if (data && typeof data === "object") {
        setTemplates(prev => ({
          ...prev,
          ...data,
        }));
      }
    })
    .catch(err => {
      console.error("Failed to load templates", err);
    });
}, []);



  const [templates, setTemplates] = useState({
    STAFF_CREATED: {
      subject: "Welcome {{first_name}} to {{company_name}}",
      body: `Hello {{first_name}},

Your staff account has been created successfully.

Role: {{role}}
Department: {{department}}
Designation: {{designation}}
State: {{state}}
Email: {{email}}

Welcome onboard.

{{company_name}}`,
    },
  });

  const template = templates[selectedEvent] || {
    subject: "",
    body: "",
  };

  const updateTemplate = (field, value) => {
    setTemplates(prev => ({
      ...prev,
      [selectedEvent]: {
        subject: prev[selectedEvent]?.subject || "",
        body: prev[selectedEvent]?.body || "",
        [field]: value,
      },
    }));
  };

  /**
   * Highlight {{variables}} in preview
   */
  const highlightVariables = text =>
    text.replace(
      /(\{\{.*?\}\})/g,
      '<span class="preview-var">$1</span>'
    );

    const handleSaveTemplate = async () => {
  setSaving(true);

  try {
   const res = await fetch(
  "http://localhost/GMT_TECHNOLOGIES_LIMITED_CLEAN/public_html/gmt-api/notifications/templates.php",
  {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      event_key: selectedEvent,
      subject: template.subject,
      body: template.body,
    }),
  }
);

    const data = await res.json();

    if (!data.success) {
      throw new Error(data.message || "Save failed");
    }

    alert("Template saved successfully");
    setShowConfirmSave(false);
  } catch (err) {
    alert("Failed to save template");
  } finally {
    setSaving(false);
  }
};


  return (
    <div className="system-notifications-page">
      {/* ================= HEADER ================= */}
      <div className="system-notifications-header">
        <h2>System Notifications</h2>
        <p>Manage automated email templates and variables</p>
      </div>

      {/* ================= MAIN GRID ================= */}
      <div className="system-notifications-grid">
        {/* LEFT: EVENTS */}
        <div className="system-events-panel">
          <h4>Email Events</h4>

          {EVENTS.map(event => (
            <button
              key={event.key}
              className={`event-btn ${
                selectedEvent === event.key ? "active" : ""
              }`}
              onClick={() => setSelectedEvent(event.key)}
            >
              {event.label}
            </button>
          ))}
        </div>

        {/* CENTER: EDITOR */}
        <div className="system-editor-panel">
          <label>Email Subject</label>
          <input
            type="text"
            className="system-input"
            value={template.subject}
            spellCheck={false}
            onChange={e =>
              updateTemplate("subject", e.target.value)
            }
          />

          <label className="mt-3">Email Body</label>
          <textarea
            rows="12"
            className="system-textarea"
            value={template.body}
            spellCheck={false}
            onChange={e =>
              updateTemplate("body", e.target.value)
            }
          />

          <div className="editor-actions">
            <button
              className="btn-secondary"
              onClick={() => setShowPreview(true)}
            >
              Preview
            </button>
           <button
  className="btn-primary"
  onClick={() => setShowConfirmSave(true)}
>
  Save Template
</button>

          </div>
        </div>

        {/* RIGHT: VARIABLES */}
        <div className="system-variables-panel">
          <h4>Available Variables</h4>

          <div className="variables-list">
            {VARIABLES.map(v => (
              <span
                key={v}
                className={`variable-chip ${
                  copiedVar === v ? "copied" : ""
                }`}
                onClick={() => {
                  navigator.clipboard.writeText(v);
                  setCopiedVar(v);
                  setTimeout(
                    () => setCopiedVar(null),
                    1500
                  );
                }}
                title="Click to copy"
              >
                {copiedVar === v ? "Copied ✓" : v}
              </span>
            ))}
          </div>

          <small className="hint">
            Click a variable to copy & paste into subject
            or body.
          </small>
        </div>
      </div>

      {/* ================= PREVIEW MODAL ================= */}
      {showPreview && (
        <div className="preview-overlay">
          <div className="preview-modal">
            <h4>Email Preview</h4>

            <div
              className="preview-content"
              dangerouslySetInnerHTML={{
                __html: highlightVariables(
                  template.body
                ).replace(/\n/g, "<br />"),
              }}
            />

            <div style={{ marginTop: 16, textAlign: "right" }}>
              <button
                className="btn-primary"
                onClick={() => setShowPreview(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}


      {showConfirmSave && (
  <div className="preview-overlay">
    <div className="preview-modal">
      <h4>Confirm Save</h4>

      <p style={{ marginTop: 8 }}>
        Are you sure you want to save this email template for{" "}
        <strong>{selectedEvent.replace("_", " ")}</strong>?
      </p>

      <div
        style={{
          marginTop: 20,
          display: "flex",
          justifyContent: "flex-end",
          gap: 12,
        }}
      >
        <button
          className="btn-secondary"
          onClick={() => setShowConfirmSave(false)}
          disabled={saving}
        >
          Cancel
        </button>

        <button
          className="btn-primary"
          onClick={handleSaveTemplate}
          disabled={saving}
        >
          {saving ? "Saving..." : "Confirm Save"}
        </button>
      </div>
    </div>
  </div>
)}

    </div>
  );
}
